import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styles from "./LoginPopUp.module.css";

const LoginPopup = ({ isLogin, isPublic = false }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);

  useEffect(() => {
    // só mostra o pop-up se:
    // 1. é uma página pública (isPublic = true)
    // 2. o usuário não está logado (!isLogin)
    // 3. o timer não foi iniciado (!timerStarted)
    if (isPublic && !isLogin && !timerStarted) {
      setTimerStarted(true);

      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [isLogin, isPublic, timerStarted]);

  const handleLoginClick = () => {
    window.open("/", "_blank");
    setShowPopup(false);
  };

  const handleCloseClick = () => {
    setShowPopup(false);
  };

  if (!showPopup) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>    
        
        <div className={styles.actions}>
          <button 
            className={`${styles.btn} ${styles.btnPrimary}`} 
            onClick={handleLoginClick}
          >
            Conhecer a Vertex4D
          </button>
          <button 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={handleCloseClick}
          >
            Continuar para visualização
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isLogin: state.auth.isLogin
});

// com connect, o redux injeta o estado (isLogin, isPublic, etc) automaticamente
export default connect(mapStateToProps)(LoginPopup);